
import { CartLinesUpdateEvent } from '@shopify/events';

function sectionIds() {
  return [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

function addUrl() {
  return window.Theme?.routes?.cart_add_url || '/cart/add.js';
}

document.addEventListener(
  'click',
  (event) => {
    const btn = event.target && event.target.closest && event.target.closest('.qt-atc');
    if (!btn || btn.disabled) return;

    const id = Number(btn.getAttribute('data-variant-id'));
    if (!id) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    const prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    const quantity = 1;
    const deferred = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(id), quantity }],
        promise: deferred.promise,
      })
    );

    const sections = sectionIds();
    const payload = {
      items: [{ id, quantity }],
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const json = await response.json();
        if (!response.ok || json.status) {
          const err = new Error(json.description || json.message || 'Add to cart failed');
          err.payload = json;
          throw err;
        }
        return json;
      })
      .then((addResponse) =>
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => ({ addResponse, cart }))
      )
      .then(({ addResponse, cart }) => {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            didError: false,
            items: cart.items,
            source: 'product-form-component',
            itemCount: cart.item_count,
            sections: addResponse.sections,
          },
        });
        btn.textContent = 'Added';
        // Fallback: if the drawer didn't open (empty-cart skip), click the bag icon.
        setTimeout(() => {
          const drawer = document.querySelector('theme-drawer#cart-drawer, #cart-drawer');
          const open = drawer && (drawer.hasAttribute('open') || drawer.getAttribute('aria-expanded') === 'true');
          if (!open) {
            document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
          }
        }, 250);
        setTimeout(() => {
          btn.textContent = prev;
          btn.disabled = false;
        }, 1400);
      })
      .catch((error) => {
        console.warn('[qt-atc]', error);
        try {
          deferred.reject(error);
        } catch (_) {}
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  },
  true
);


/* qt-salt-both: when Smell is Both, Quantity buttons mean 1/2/3 of each scent */
(function () {
  const SINGLE = [
    "1 stick · $28.97",
    "2 sticks · $52.97 · save 10%",
    "3 sticks · $73.97 · save 15%",
  ];
  const BOTH = [
    "1 of each · $52.97 · save 10%",
    "2 of each · $98.97 · save 15%",
    "3 of each · $147.97 · save 15%",
  ];
  const isSalt = () => /salt-stone-deodorant/.test(location.pathname);
  const smellIsBoth = () => {
    const labels = document.querySelectorAll("variant-picker .variant-option");
    for (const opt of labels) {
      const legend = (opt.querySelector("legend") || {}).textContent || "";
      if (!/smell/i.test(legend)) continue;
      const checked = opt.querySelector("input:checked");
      const txt = (checked && (checked.value || checked.getAttribute("value") || "")) + " " +
        ((checked && checked.closest("label") && checked.closest("label").textContent) || "");
      if (/both/i.test(txt)) return true;
    }
    return /both/i.test((document.querySelector('input[name="id"]') || {}).title || "");
  };
  const paint = () => {
    if (!isSalt()) return;
    const both = smellIsBoth();
    const qtyBox = [...document.querySelectorAll("variant-picker .variant-option")].find((opt) =>
      /quantity/i.test(((opt.querySelector("legend") || {}).textContent || ""))
    );
    if (!qtyBox) return;
    const texts = qtyBox.querySelectorAll(".variant-option__button-label__text, .variant-option__button-label");
    const src = both ? BOTH : SINGLE;
    let i = 0;
    texts.forEach((el) => {
      // only rewrite the innermost text node wrapper if present
      if (el.classList.contains("variant-option__button-label") && el.querySelector(".variant-option__button-label__text")) return;
      if (i < src.length) {
        el.textContent = src[i++];
      }
    });
  };
  document.addEventListener("change", (e) => {
    if (e.target && e.target.closest && e.target.closest("variant-picker")) setTimeout(paint, 20);
  });
  document.addEventListener("variant:change", () => setTimeout(paint, 20));
  document.addEventListener("variant:update", () => setTimeout(paint, 20));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", paint);
  else paint();
  setTimeout(paint, 400);
})();
